import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import deviceAlertServices from "app/services/automations/device-alert-services";
import AlertRuleEditor from "./AlertRuleEditor";
import { AlertRuleCardDetails, AlertRuleCardSummary, alertRuleSubtitle } from "./AlertRuleSummary";

// Reglas («Avisar o actuar cuando pase algo», DeviceAlertRule en el backend).
const alertRuleType = {
    key: "alert_rule",
    label: "Regla",
    pickerTitle: "Avisar o actuar cuando pase algo",
    pickerDescription: "Avisa por correo o WhatsApp, o enciende o apaga un equipo, cuando tus sensores cumplen una condición.",
    icon: RuleOutlinedIcon,
    order: 10,
    Editor: AlertRuleEditor,
    CardSummary: AlertRuleCardSummary,
    CardDetails: AlertRuleCardDetails,
    subtitle: alertRuleSubtitle,
    statusChip: () => null,
    setEnabled: (item, enabled) => deviceAlertServices.updateRule(item.id, "", { device_alert_rule: { enabled } }),
    remove: (item) => deviceAlertServices.deleteRule(item.id),
    confirmRemove: (item) => `¿Eliminar la automatización "${item.name || `#${item.id}`}"?`,
    canDuplicate: true,
    draftTypes: ["automation_rule"],
    draftTarget: (message) => {
        const payload = message?.draft_payload || {};
        const rule = payload.device_alert_rule || payload.rule || payload;
        return payload.mode === "update" ? (rule.id || payload.target_id || null) : null;
    },
};

export default alertRuleType;
